import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import LabelStageNames from './LabelStageNames-redux';

export default compose(
  withRouter,
)(LabelStageNames);
